module.exports = __webpack_public_path__ + "static/img/4.914e439a.jpg";